import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * 앱 전역 테마 프로바이더.
 *
 * - 속성: `<html data-theme="light|dark">` 에 적용 — tokens.css 의
 *   `[data-theme='light']` / `[data-theme='dark']` 선택자와 매칭.
 * - 기본값: `light` (기존 디자인 호환).
 * - 시스템 테마 추적은 일단 비활성. 추후 `enableSystem`/`'system'` 옵션 도입 가능.
 * - 테마 전환 시 트랜지션 깜빡임 방지(`disableTransitionOnChange`).
 *
 * 다크 토큰은 `app/styles/tokens.css` 에 이미 정의되어 있어 별도 CSS 필요 없음.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      // 두 attribute 동시 토글:
      // - `data-theme`: tokens.css 의 [data-theme='dark'] 변수 (--bs-*) 잡힘
      // - `class`: index.css 의 .dark 변수 (--background, --card 등 Shadcn 변수) 잡힘
      attribute={['class', 'data-theme']}
      defaultTheme='light'
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
